import React from 'react';
import { Rate } from 'antd';
import moment from 'moment-timezone';
import note from '../images/noteico.png';
import { map } from 'lodash';

// maping STATUS for hardcoded
const STATUS = {
  forecast: "Forecast",
  tentative: 'Tentative',
  paused: 'Paused',
  scheduled: 'Scheduled',
  technician_assigned: 'Technician Assigned',
  technician_en_route: 'Technician En Route',
  in_progress: 'In Progress',
  complete: 'Complete',
  cancelled: 'Cancelled'
};



const status2 = {
  pet_waste_station_service: "Pet Waste Station Service",
  common_area_cleaning: "Common Area Cleaning",
  trash_can_service: "Trash Can Service",
  pet_waste_stations: "Pet Waste Stations",
  pet_waste_station_bags: "Pet Waste Station Bags",
}

class DataTable {
  InvoiceWeb = (self) => {
    const invoiceColumns = [
      {
        title: 'Date',
        dataIndex: 'invoice_date',
        key: 'invoice_date',
        sorter: false,
        render: (text,record) => (<b className="date">{record?.invoice_date?record?.invoice_date:record?.date_creditmemo}</b>)
      },

      {
        title: 'Type',
        dataIndex: 'uuid',
        key: 'uuid',
        sorter: false,
        render: (text,record) => (<span className="type">{record?.invoice_date?"Invoice":"Credit Memo"}</span>)
      },
      {
        title: 'Invoice/Credit Memo',
        dataIndex: 'invoice_id',
        key: 'invoice_id',
        sorter: false,
        render: (text,record) => (<span className="invoice_id">{record?.invoice_id?record?.invoice_id:record?.creditmemo_id}</span>)
      },
      {
        title: 'Due Date',
        dataIndex: 'due_date',
        key: 'due_date',
        sorter: false,
        render: (text,record) => (<span className="due_Date">{record.invoice_id?moment(record?.due_date).format('MM/DD/YYYY'):"N/A"}</span>)
      },
      {
        title: 'Balance',
        dataIndex: 'balance_due',
        key: 'balance_due',
        sorter: false,
        render: (text, record) => (<span className="balance">${record.creditmemo_id && record.remaining_balance>0?"-":null}{record?.balance_due?record?.balance_due:record?.remaining_balance}</span>)
      },
      {
        title: 'Total',
        dataIndex: 'total',
        key: 'total',
        sorter: false,
        render: (text,record) => (<span className="total">${record.creditmemo_id && record.total>0?"-":null}{record.total_with_tax}</span>)
      },
      // {
      //   title: 'Date Paid',
      //   dataIndex: 'date_paid',
      //   key: 'date_paid',
      //   sorter: false,
      //   render: (text) => (<span className="date_paid">{text ? moment(text).format('MM/DD/YYYY') : '-'}</span>)
      // },
      {
        title: 'Payment Method',
        dataIndex: 'payment_method_type',
        key: 'payment_method_type',
        sorter: false,
        render: (text) => (<span className="payment_method">{text ? text : '-'}</span>)
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        sorter: false,
        render: (text, record) => (<span className={
          record.status === 'overdue' ? 'status danger t-capitalize' : record.status === 'open-emailed' ? 'status success t-capitalize' : 'status t-capitalize'
        }  >{text}</span>)
      },
      {
        title: ' ',
        dataIndex: 'uuid',
        key: 'uuid',
        sorter: false,
        render: (text, record) => (<span className="view" onClick={() => {
          self.setState({
            is_edit_info: true,
            curr_invoice: record
          })
        }}>View</span>)
      },
    ]
    return invoiceColumns;
  }
  InvoiceMobile = () => {
    const invoiceColumns = [
      {
        title: 'Date',
        dataIndex: 'invoice_date',
        key: 'invoice_date',
        sorter: false,
        render: (text) => (<b className="date">{moment(text).format("MM/DD/YYYY")}</b>)
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        sorter: false,
        render: (text, record) => (<span className={
          record.status === 'overdue' ? 'status danger t-capitalize' : record.status === 'open-emailed' ? 'status success t-capitalize' : 'status t-capitalize'
        }  >{text}</span>)
      },

    ]
    return invoiceColumns;
  }


  Service = () => {
    const serviceColumns = [
      {
        title: 'Date',
        dataIndex: 'scheduled_time',
        key: 'scheduled_time',
        sorter: false,
        render: (scheduled_time) => (
          <div className="">
            <strong className="date">{moment(scheduled_time).format('MMM DD, YYYY')}</strong>
            <span className="msg">
              <span className="msgtext"></span>
              <span className="policy"><u>View (Franchise) Policy</u></span>
            </span>
          </div>)
      },
      {
        title: 'Time',
        dataIndex: 'scheduled_time',
        key: 'scheduled_time',
        sorter: false,
        render: (scheduled_time) => (<strong className="time">{moment(scheduled_time).format('hh:mm A')}</strong>)
      },
      {
        title: 'Tech',
        dataIndex: 'tech',
        key: 'tech',
        sorter: false,
        render: (text) => (<span className="tech">{text}</span>)
      },
      {
        title: 'Feedback',
        dataIndex: 'rating',
        key: 'rating',
        sorter: false,
        render: (text, record) => (<span className="feedback">{console.log("record::::>",record)}  <Rate allowHalf disabled value={record.rating} />
        </span>)
      },

      {
        title: '',
        dataIndex: 'technician_image',
        key: 'technician_image',
        sorter: false,
        render: (text, record) => (<span className="note">{record.technician_comment ? record.technician_comment : ''}
          {record.technician_image ? <figure><img src={note} alt="" /></figure> : ''}
        </span>)
      },
      {
        title: '',
        dataIndex: 'ticket',
        key: 'ticket',
        sorter: false,
        render: () => (
          <span></span>
          // <span className="ticket">{text}</span>
        )
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        sorter: false,
        render: (text, record) => (<span className="status">{STATUS[record.status]}</span>)
      }
    ]
    return serviceColumns;
  }

  Proposals = (self) => {
    const proposalsColumns = [
      {
        title: 'Date Created',
        dataIndex: 'created_at',
        key: 'created_at',
        className: 'pr-5',
        sorter: false,
        render: (text) => (<b className="date">{text ? moment(text).format('MM/DD/YYYY') : '-'}</b>)
      },
      {
        title: 'Type',
        dataIndex: 'is_looking_for_proposal',
        key: 'is_looking_for_proposal',
        className: 'pr-5',
        sorter: false,
        render: (text) => (<b className="date">{text ? 'Proposal' : 'Enquiry'}</b>)
      },
      {
        title: 'Community',
        dataIndex: 'community_name',
        key: 'community_name',
        sorter: false,
        render: (text) => (<b className="date">{text}</b>)
      },
      {
        title: 'Proposal Due',
        dataIndex: 'proposal_due',
        key: 'proposal_due',
        sorter: false,
        render: (text) => (<b className="date">{text ? moment(text).format("MM/DD/YYYY") : '-'}</b>)
      },
      {
        title: 'Service/Product Needs',
        dataIndex: 'interested_products',
        key: 'interested_products',
        className: 'lfbdr pr-3',

        sorter: false,

        render: (text, record) => (<b className="date">{map(text, (item) => { return (<span key={item}>{status2[item]},</span>) })}
          {text.length > 0 ? <br /> : ''}
          { map(record.interested_services, (item) => { return (<span key={item}>{status2[item]},</span>) })}</b>)
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        sorter: false,
        className: 'pr-3',
        render: (text) => (<b className="date">{text === 'open' ? <span className="status success t-capitalize">Open</span> : ''}</b>)
      },
      {
        title: '',
        dataIndex: 'uuid',
        key: 'uuid',
        sorter: false,
        className: 'pr-2',
        render: (text) => (<span className="view" onClick={() => {
          self.setState({ loader: true });
          setTimeout(() => {
            self.setState({ loader: false });
          }, 9000);
          self.props.getProposalPdf(text);
        }}>View Proposal</span>)
      },



    ]
    return proposalsColumns;
  }
}

export default new DataTable();